$(function () {
    // Configs
    var $globalConf = $('.js-global-conf');
    var $conf = $('.js-conf');

    //GA4 - view offer detail
    viewOfferEventSE({
        id: offerData.offerID,
        title: offerData.title,
        company: offerData.company,
        salary: offerData.salary,
        profession: offerData.profession,
        experience: offerData.experience,
        education: offerData.educationLevel,
        sector: offerData.sector,
        equivalentPositions: offerData.equivalentPositions,
        industry: offerData.industry,
        location: offerData.location,
        quantity: offerData.vacancy,
        level: offerData.offerLevel,
        tags: offerData.keywords,
        contract: offerData.contract
    });

    // Modules
    var offerDetailsServices = new OfferDetailsServices();
    var applyOfferController = new ApplyOfferController({
        $globalConf: $globalConf,
        $conf: $conf,
        offerDetailsServices: offerDetailsServices
    });

    // Btn apply for mobile affix
    var $footer = $('.js-eesites-footer');
    var $applyOfferFixed = $('.js-eesites-fixed-buttons');

    // Char counter for textarea in offer share modal
    var $textAreaShare = $('.js-shareOffer');
    var $charCounterShare = $textAreaShare.next().find('.js-char-counter');
    var charCounterShareOffer = new CharCounter({
        controlToLimit: $textAreaShare,
        counterControl: $charCounterShare,
        maxCharacters: 300
    });;

    // Truncate offers name in Similar offers
    var $offerNameLink = $('.js-offer-name');
    var $publishDescription = $('.js-publish-description');

    // Share offer
    var $formShareOffer = $('form.js-offer-share');
    var $modalShare = $('.js-modal-share');
    var $formShareAlert = $formShareOffer.find('.js-form-alert');

    function evalFooterHeight() {
        footerHeight = $footer.outerHeight() + 85;
        return footerHeight;
    }

    function applyOffer(event) {
        event.preventDefault();

        var params = {};
        var $form = $(this);
        var url;

        params = $form.serialize();
        url = $form.attr('action');

        offerDetailsServices
            .getResults(params, url)
            .then(function (data) {
                console.log(data);
            })
            .fail(function (param) {
                console.log(param);
            });
    }

    function shareOffer(event) {
        event.preventDefault();

        $('.rc-alert').remove();
        var rcres = grecaptcha.getResponse();

        if (rcres.length !== 0) {
            if ($formShareOffer.valid() && rcres.length !== 0) {
                var params = $formShareOffer.serialize();

                var url = $formShareOffer.attr('action');

                offerDetailsServices
                    .getResults(params, url)
                    .then(function (data) {
                        eeGlobal.notification.clean();

                        $formShareOffer[0].reset();
                        grecaptcha.reset();
                        $modalShare.modal('hide');

                        $('.js-eesites-offer-notifications').html('');

                        eeGlobal.notification.success({
                            title: $conf.data('shared-title'),
                            copy: data.Message,
                            $target: $('.js-eesites-offer-notifications')
                        });

                        eeGlobal.notification.success({
                            title: $conf.data('shared-title'),
                            copy: data.Message
                        });

                    }).fail(function (data) {
                        eeGlobal.notification.clean();
                        grecaptcha.reset();

                        eeGlobal.notification.error({
                            title: $conf.data('shared-title'),
                            copy: data.statusText,
                            $target: $('.js-eesites-offer-notifications')
                        });
                    });
            }
        } else {
            $('.g-recaptcha').after('<span class="rc-alert" style="display: block; color: #d22c0b; font-size: 13px; font-family: \'Ubuntu\', \'Helvetica\', sans-serif; font-style: italic;">*Por favor, completa la verificaci&oacute;n del reCAPTCHA.</span>');
        }
    }

    $applyOfferFixed.affix({
        offset: {
            bottom: evalFooterHeight
        }
    });

    // Truncate offer name and description in similar offers
    $offerNameLink.add($publishDescription).trunk8({
        lines: 2,
        parseHTML: false,
        tooltip: false
    });

    $formShareOffer.on('submit', shareOffer);

    //Button Close Alerts
    // TODO: Include this functionality in notification module
    $('.alert .close').click(function () {
        $('.close').alert('close');
    });

    //Shared offer    
    const tooltip = document.getElementById('tooltip');
    const menu = document.getElementById('shareMenu');
    const toggleBtn = document.getElementById('shared');
    const clipboardBtn = document.getElementById('share-clipboard');

    toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        menu.classList.toggle('active');
    });

    clipboardBtn.addEventListener('click', function (e) {
        e.preventDefault();
        navigator.clipboard.writeText(window.location.href).then(function () {
            mostrarTooltip();
        });
    });

    function mostrarTooltip() {
        tooltip.classList.add('show');
        menu.classList.remove('active');
        setTimeout(function () {
            tooltip.classList.remove('show');
        }, 2000);
    }

    document.querySelectorAll('.share-item a').forEach(function (item) {
        item.addEventListener('click', function () {
            setTimeout(function () {
                menu.classList.remove('active');
            }, 200);
        });
    });

    document.addEventListener('click', function (event) {
        const isInside = toggleBtn.contains(event.target) || menu.contains(event.target);
        if (!isInside) {
            menu.classList.remove('active');
        }
    });

});
